import { render, staticRenderFns } from "./BranchOfficeButton.vue?vue&type=template&id=33b4b912&lang=pug&"
import script from "./BranchOfficeButton.vue?vue&type=script&lang=js&"
export * from "./BranchOfficeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BranchOfficeButton.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
